import { graphql } from "@/gql";

export const openIncidentClaimMutation = graphql(`
  mutation OpenIncidentClaim($id: ID!, $input: OpenIncidentClaimInput!) {
    openIncidentClaim(id: $id, input: $input) {
      id
      status
    }
  }
`);
